import { Vue, i18n } from "Common/vue";

/**
 * Initialize Vue Product Variations component
 *
 * @return {Promise<void>}
 */
export default async function initializeVueProductVariations() {
    const productVariationsEl = document.querySelector(".js-vue-product-variations");

    // Skip initialization if the element is not present.
    // This can happen if the product does not have variations.
    if (!productVariationsEl) {
        return;
    }

    // Lazy load the component and store
    const [ProductVariationsComponent, productVariationsStore] = await Promise.all([
        import("VueComponents/productVariations/ProductVariations.vue"),
        import("VueComponents/productVariations/store/_store"),
    ]);

    const skeletonEl = productVariationsEl.querySelector(".js-vue-product-variations-skeleton");

    // Expose the store to the global scope
    window.$_productVariationsStore = productVariationsStore.default;

    // Initialize the Vue Product Variations component
    window.$_productVariations = new Vue({
        i18n,
        store: productVariationsStore.default,
        render: (h) =>
            h(ProductVariationsComponent.default, {
                props: {
                    productId: productVariationsEl.dataset.productId,
                    variationId: productVariationsEl.dataset.variationId,
                    initialSkeletonContent: skeletonEl?.innerHTML || null,
                },
            }),
    }).$mount(productVariationsEl);
}
